module.exports = __webpack_public_path__ + "img/buenos_aires_la_boca.efb88ef0.jpg";